import React, { useState } from "react";
import { useStyles } from "../../../assets/jss/PraisoTable";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import {
    EntityAccess,
    MileageClaimStatusEnum,
    RBAC_CODE,
    ReportedEventStatus,
    ReportEventEnum,
    TableView,
} from "../../../config/app-globals.enum";
import { getUserRBAC } from "../../../services/LocalStorageService";
import { CustomMoreVertIcon } from "../../CustomComponents/CustomIcon/CustomIcon";
import CustomMenu from "../../CustomComponents/CustomMenu/CustomMenu";
import CustomMenuItem from "../../CustomComponents/CustomMenuItem/CustomMenuItem";
import CustomIconButton from "../CustomIconButton/CustomIconButton";
import { approveRejectEvent, reportEvent } from "../../../services/PraisoTableService";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import ApproveConfirmActionDialog from "../../Dialogs/ConfirmAction/ApproveAction";
import ReportEventActionDialog from "../../Dialogs/ConfirmAction/ReportEventAction";
import RejectAction from '../../Dialogs/ConfirmAction/RejectAction';
import MileageClaimActionDialog from "../../Dialogs/ConfirmAction/MileageClaimAction";
import { approveRejectMileageClaim } from "../../../services/MileageClaimAPIService";


export const RowAction = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    // const params = useParams();
    const [getRBAC] = React.useState(getUserRBAC(null, props));
    const history = useHistory();
    const [userRowActionEl, setUserRowActionEl] = useState(null);
    const handleUserRowActionClick = (event) => {
        setUserRowActionEl(event.currentTarget);
    };
    const handleUserRowActionClose = (text) => {
        setUserRowActionEl(null);
    };
    const handleRefreshComponent = props.callBackFun;

    const actions = React.useMemo(() => {
        if (props && props.options && props.options.length) {
            return props.options;
        } else {
            return [];
        }
    }, [props.options]);

    const [openReport, setOpenReport] = React.useState(false);
    const handleCloseReport = (isOpen, confirmDelete) => {
        if (confirmDelete) {
            handleApproveReject(props.rowInfo.row.original, ReportEventEnum.APPROVE, "");
        } else {
            setOpenReport(isOpen);
        }

    };
    const handleOpenReport = () => {
        setOpenReport(true);
        setUserRowActionEl(null);
    };

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogAction] = useState("save");

    const deleteDialogFunc = (isOpen, confirmDelete, reason) => {
        if (confirmDelete) {
            handleApproveReject(props.rowInfo.row.original, ReportEventEnum.REJECT, reason);
        } else {
            setDialogOpen(isOpen);
        }
    };

    // ----
    const [eventStatusValue, setEventStatusValue] = React.useState(null);
    const [eventAlertType, setEventAlertType] = React.useState("");
    const [eventAlertMessage, setEventAlertMessage] = React.useState("");
    const [eventAlertDescription, setEventAlertDescription] = React.useState("");
    const [isEventAlertOpen, setIsEventAlertOpen] = React.useState(false);
    const changeEventApiStatusCodeFunc = (status, action) => {
        setEventStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setEventAlertMessage(status.message ? status.message : t("SUCCESS"));
            setEventAlertType("success");
            let eventDescription = "";
            if (action === ReportEventEnum.REPORT_EVENT) {
                eventDescription = t("EVENT_HAS_BEEN_REPORTED_SUCCESSFULLY");
            } else if (action === ReportEventEnum.APPROVE) {
                eventDescription = t("EVENT_HAS_BEEN_APPROVED_SUCCESSFULLY");
            } else if (action === ReportEventEnum.REJECT) {
                eventDescription = t("EVENT_HAS_BEEN_REJECTED_SUCCESSFULLY");
            }

            setEventAlertDescription(eventDescription);
        } else {
            setEventAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setEventAlertType("error");
            let eventDescription = "";
            if (action === ReportEventEnum.REPORT_EVENT) {
                eventDescription = t("FAILED_TO_REPORT_EVENT");
            } else if (action === ReportEventEnum.APPROVE) {
                eventDescription = t("FAILED_TO_APPROVE_EVENT");
            } else if (action === ReportEventEnum.REJECT) {
                eventDescription = t("FAILED_TO_REJECT_EVENT");
            }
            setEventAlertDescription(eventDescription);
        }
        setIsEventAlertOpen(true);
    };

    async function loadData(req, value) {
        const request = {
            eventId: req.eventId,
            userId: req.userId,
            occurredAt: req.occurredAt,
            reason: value
        }
        const data = await reportEvent(request);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            changeEventApiStatusCodeFunc(data.status, ReportEventEnum.REPORT_EVENT);
            setTimeout(() => {
                window.localStorage.removeItem("API");
                // window.location.reload();
                handleRefreshComponent(ReportEventEnum.REPORT_EVENT);
            }, 200);
            //@todo reload data
        } else {
            changeEventApiStatusCodeFunc(data.status, ReportEventEnum.REPORT_EVENT);
        }
        setOpen(false);
    }

    const [open, setOpen] = React.useState(false);
    const handleClose = (isOpen, confirmDelete, value) => {
        if (confirmDelete) {
            loadData(props.rowInfo.row.original, value);
        } else {
            setOpen(isOpen);
        }
    };
    const handleOpen = () => {
        setOpen(true);
        setUserRowActionEl(null);
    };

    const isTimePeriodOver = (param) => {
        return false;
        // let result = false;
        // if (reportEventPeriod !== null) {
        //     const curDate = new Date();
        //     const occuredDate = new Date(param);
        //     occuredDate.setHours(0, 0, 0, 0);
        //     const expiryDate = new Date(occuredDate.getTime() + (reportEventPeriod * 24 * 60 * 60 * 1000));
        //     if (expiryDate.getTime() < curDate.getTime()) {
        //         result = true;
        //     }
        // }
        // return result;
    };

    async function handleApproveReject(req, eventStatus, reason) {
        let request = {
            userId: req.userId,
            reportStatus: eventStatus === ReportEventEnum.APPROVE ? ReportedEventStatus.APPROVED : ReportedEventStatus.REJECTED, //Approve-2;Reject-3
            reason: null
        }
        if (reason && reason.length > 0) {
            request = {
                ...request,
                reason: reason,
            }
        }
        const data = await approveRejectEvent(request, req.eventId);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            changeEventApiStatusCodeFunc(data.status, eventStatus);
            setTimeout(() => {
                handleRefreshComponent(eventStatus);
                window.localStorage.removeItem("API");
            }, 200);
            //@todo reload data
        } else {
            changeEventApiStatusCodeFunc(data.status, eventStatus);
        }
        if (eventStatus === ReportEventEnum.APPROVE) {
            setOpenReport(false);
        } else {
            setDialogOpen(false);
        }
    }

    //--- Mileage Claim
    const [mileageClaimStatus, setMileageClaimStatus] = useState(MileageClaimStatusEnum.CLAIMED);
    const [mileageClaimDialogOpen, setMileageClaimDialogOpen] = useState(false);
    const rejectMileageClaimDialogFunc = (isOpen, confirmDelete, reason) => {
        if (confirmDelete) {
            if (mileageClaimStatus === MileageClaimStatusEnum.APPROVED) {
                handleMileageClaimApproveReject(props.rowInfo.row.original, MileageClaimStatusEnum.APPROVED, null);
            } else if (mileageClaimStatus === MileageClaimStatusEnum.REJECTED) {
                handleMileageClaimApproveReject(props.rowInfo.row.original, MileageClaimStatusEnum.REJECTED, reason);
            }
        } else {
            setMileageClaimDialogOpen(isOpen);
        }
    };

    const mileageClaimMenuItemClicked = (action: any) => {
        setMileageClaimStatus(action.label === 'Approve' ? MileageClaimStatusEnum.APPROVED : MileageClaimStatusEnum.REJECTED);
        setUserRowActionEl(null);
        setMileageClaimDialogOpen(true)
    }

    async function handleMileageClaimApproveReject(req, mileageClaimStatus, reason) {
        let request = {
            userId: req.userId,
            status: mileageClaimStatus,
            reason: null
        }
        if (reason && reason.length > 0) {
            request = {
                ...request,
                reason: reason,
            }
        }
        const data = await approveRejectMileageClaim(request, req._id);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            changeMileageClaimApiStatusCodeFunc(data.status, mileageClaimStatus);
            setTimeout(() => {
                handleRefreshComponent(mileageClaimStatus);
                window.localStorage.removeItem("API");
            }, 1000);
            //@todo reload data
        } else {
            changeMileageClaimApiStatusCodeFunc(data.status, mileageClaimStatus);
        }
        setMileageClaimDialogOpen(false);
    }

    const changeMileageClaimApiStatusCodeFunc = (status, action) => {
        setEventStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setEventAlertMessage(status.message ? status.message : t("SUCCESS"));
            setEventAlertType("success");
            let eventDescription = "";
            if (action === MileageClaimStatusEnum.CLAIMED) {
                eventDescription = t("MILEAGE_HAS_BEEN_CLAIMED_SUCCESSFULLY");
            } else if (action === MileageClaimStatusEnum.APPROVED) {
                eventDescription = t("MILEAGE_HAS_BEEN_APPROVED_SUCCESSFULLY");
            } else if (action === MileageClaimStatusEnum.REJECTED) {
                eventDescription = t("MILEAGE_HAS_BEEN_REJECTED_SUCCESSFULLY");
            }

            setEventAlertDescription(eventDescription);
        } else {
            setEventAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setEventAlertType("error");
            let eventDescription = "";
            if (action === MileageClaimStatusEnum.CLAIMED) {
                eventDescription = t("FAILED_TO_CLAIM_MILEAGE");
            } else if (action === MileageClaimStatusEnum.APPROVED) {
                eventDescription = t("FAILED_TO_APPROVE_MILEAGE");
            } else if (action === MileageClaimStatusEnum.REJECTED) {
                eventDescription = t("FAILED_TO_REJECT_MILEAGE");
            }
            setEventAlertDescription(eventDescription);
        }
        setIsEventAlertOpen(true);
    };
    // ---

    return (
        <>
            {actions && actions.length ? (
                <>
                    <CustomIconButton
                        aria-controls={`user-row-action-${props.rowInfo.row.id}`}
                        aria-haspopup="true"
                        onClick={handleUserRowActionClick}
                        className={classes.actionButton}
                    >
                        <CustomMoreVertIcon />
                    </CustomIconButton>
                    <CustomMenu
                        id={`user-row-action-${props.rowInfo.row.id}`}
                        anchorEl={userRowActionEl}
                        keepMounted
                        open={Boolean(userRowActionEl)}
                        onClose={handleUserRowActionClose}
                    >
                        {
                            actions.map((action) => {
                                return getRBAC && getRBAC.find(
                                    (item) =>
                                        item.entityCode === RBAC_CODE[action.linkEntity] &&
                                        item.isAccessible === EntityAccess.ALLOWED
                                ) ?
                                    (action.isVisibleProps === null || action.isVisibleProps === undefined || (action.isVisibleProps && props.rowInfo.row.original[action.isVisibleProps])
                                        ?
                                        action.linkEntity === "MILEAGE_CLAIM" ?
                                            <CustomMenuItem key={action.label} onClick={() => mileageClaimMenuItemClicked(action)}>
                                                {t(`TABLE_ROW_ACTION_LABEL_${action.label.replace(/\s/g, "")}`)}
                                            </CustomMenuItem>
                                            :
                                            (
                                                (props.rowInfo.row.original.reportStatus === ReportedEventStatus.NO_REPORT || props.rowInfo.row.original.reportStatus === ReportedEventStatus.EXPIRED) && isTimePeriodOver(props.rowInfo.row.original.occurredAt) && action.label === ReportEventEnum.REPORT_EVENT ? null : <CustomMenuItem key={action.label} disabled={(props.rowInfo.row.original.reportStatus === ReportedEventStatus.REPORTED || props.rowInfo.row.original.reportStatus === ReportedEventStatus.REJECTED || isTimePeriodOver(props.rowInfo.row.original.occurredAt)) && action.label === ReportEventEnum.REPORT_EVENT ? true : false}
                                                    onClick={() =>
                                                        (props.tableView === TableView.BRAKING_EVENT_LIST || props.tableView === TableView.BRAKING_EVENT_USER_LIST ||
                                                            props.tableView === TableView.CORNERING_EVENT_LIST || props.tableView === TableView.CORNERING_EVENT_USER_LIST ||
                                                            props.tableView === TableView.SPEEDING_EVENT_LIST || props.tableView === TableView.SPEEDING_EVENT_USER_LIST ||
                                                            props.tableView === TableView.DISTRACTION_EVENT_LIST || props.tableView === TableView.MOBILE_DISTRACTION ||
                                                            props.tableView === TableView.ACCELERATION_EVENT_LIST || props.tableView === TableView.ACCELERATION_EVENT_USER_LIST
                                                        )
                                                            // ? (action.label === ReportEventEnum.REPORT_EVENT ? handleOpen() : history.push(`/eventdetails/${props.rowInfo.row.original.userId}/${props.rowInfo.row.original.eventId}/${props.rowInfo.row.original.reportStatus === ReportedEventStatus.EXPIRED ? ReportedEventStatus.NO_REPORT : props.rowInfo.row.original.reportStatus !== undefined ? props.rowInfo.row.original.reportStatus : (props.tableView === TableView.MOBILE_DISTRACTION || props.tableView === TableView.DISTRACTION_EVENT_LIST) ? ReportedEventStatus.DISTRACTION_EVENT : ReportedEventStatus.NO_REPORT}`)) :
                                                            ? (action.label === ReportEventEnum.REPORT_EVENT ? handleOpen() : history.push(`/eventdetails/${props.rowInfo.row.original.userId}/${props.rowInfo.row.original.eventId}/${props.rowInfo.row.original.reportStatus === ReportedEventStatus.EXPIRED ? ReportedEventStatus.NO_REPORT : (props.tableView === TableView.MOBILE_DISTRACTION || props.tableView === TableView.DISTRACTION_EVENT_LIST) ? ReportedEventStatus.DISTRACTION_EVENT : props.rowInfo.row.original.reportStatus !== undefined ? props.rowInfo.row.original.reportStatus : ReportedEventStatus.NO_REPORT}`)) :
                                                            props.tableView === TableView.REPORT_EVENTS ||
                                                                props.tableView === TableView.BRAKING_REPORTED_EVENTS ||
                                                                props.tableView === TableView.CORNERING_REPORTED_EVENTS ||
                                                                props.tableView === TableView.ACCELERATION_REPORTED_EVENTS ||
                                                                props.tableView === TableView.DISTRACTION_REPORTED_EVENTS
                                                                ? (action.label === ReportEventEnum.APPROVE ? handleOpenReport() : setDialogOpen(true)) :
                                                                (history.push(
                                                                    `${action.linkUrl}/${props.rowInfo.row.original[action.linkParam]
                                                                    }`,
                                                                    {
                                                                        from: history.location,
                                                                    }
                                                                ))
                                                    }
                                                >
                                                    {
                                                        t(`TABLE_ROW_ACTION_LABEL_${action.label.replace(/\s/g, "")}`)
                                                    }
                                                </CustomMenuItem>
                                            ) : null
                                    ) : null;
                            })
                        }

                    </CustomMenu>
                </>
            ) : null}
            <ErrorAlert
                code={eventStatusValue}
                message={eventAlertMessage}
                description={eventAlertDescription}
                isOpen={isEventAlertOpen}
                alertType={eventAlertType}
                isClose={(isClose) => setIsEventAlertOpen(!isClose)}
            />
            <RejectAction
                dialogOpen={dialogOpen}
                dialogClose={(isOpen, confirmDelete, reason) =>
                    deleteDialogFunc(isOpen, confirmDelete, reason)
                }
                dialogMessage={t("ARE_YOU_SURE_YOU_WANT_TO_REJECT_THE_REPORTED_EVENT")}
                dialogAction={dialogAction}
            />
            <ApproveConfirmActionDialog
                tab={props.tableView}
                dialogOpen={openReport}
                dialogClose={(isOpen, confirmDelete) =>
                    handleCloseReport(isOpen, confirmDelete)
                }
            />
            <ReportEventActionDialog
                dialogOpen={open}
                dialogClose={(isOpen, confirmDelete, value) =>
                    handleClose(isOpen, confirmDelete, value)
                }
            />

            {/* Mileage Claim */}
            {mileageClaimDialogOpen &&
                <MileageClaimActionDialog
                    dialogOpen={mileageClaimDialogOpen}
                    dialogClose={(isOpen, confirmReject, reason) =>
                        rejectMileageClaimDialogFunc(isOpen, confirmReject, reason)
                    }
                    mileageClaimStatus={mileageClaimStatus}
                    dialogMessage={mileageClaimStatus === MileageClaimStatusEnum.APPROVED ? t("ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THE_MILEAGE_CLAIM") : t("ARE_YOU_SURE_YOU_WANT_TO_REJECT_THE_MILEAGE_CLAIM")}
                />
            }
        </>
    );
};
